// @flow

// force flow to type check this file - https://github.com/zapier/zapier/pull/31127
import React from 'react'; /* eslint-disable-line no-unused-vars */

import Avatar from '../Avatar';
import Text from '../Text';
import { Colors } from '@zapier/theme';
import { RelativeTime } from '@zapier/date';
import { jsx } from '@emotion/core';

/** @jsx jsx */

type Props = {
  comment: string,
  name: string,
  createdAt: string,
  company: ?string,
  photoUrl: ?string,
};

const commentWrapperCss = {
  display: 'grid',
  'grid-column-gap': 20,
  'grid-template-columns': 'auto 1fr',
};

const contentWrapperCss = {
  color: Colors.batmobile,
  paddingTop: 5,
};

const getAvatarLetter = (name: string) => name.charAt(0);
const getCompany = (company: ?string) =>
  company ? <span>, {company}</span> : null;

const Comment = ({ comment, name, createdAt, company, photoUrl }: Props) => {
  return (
    <div css={commentWrapperCss}>
      <Avatar name={getAvatarLetter(name)} size={50} url={photoUrl || ''} />
      <article css={contentWrapperCss}>
        <strong css={{ color: Colors.deepSpace }}>
          {name}
          {getCompany(company)}
        </strong>
        <span css={{ padding: '0 5px' }}>&#183;</span>
        <RelativeTime date={createdAt} />
        <p
          css={{
            margin: '10px 0 0 0',
          }}
        >
          <Text type="body">{comment}</Text>
        </p>
      </article>
    </div>
  );
};

export default Comment;
